export { SuiCheckboxModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/checkbox/public.js
// module id = 1097
// module chunks = 0